import Bouncer from 'formbouncerjs';
import {
  isFormProcessing,
  markFormProcessing,
  grecaptchaV3Execute,
  logToPHP,
  glsAjax,
} from './scripts';

const $j = jQuery.noConflict();
const MAX_BOOKLETS = 100;
const PACKET_SIZE = 25;

function fadeOutMessages() {
  $j("div[name$='-message']").fadeOut(250).html('');
}

let focusCount = 0;

function onFocusFadeOutMessages() {
  $j('input').on('focus', function handleFocus() {
    focusCount += 1;
    if (focusCount === 2) {
      fadeOutMessages();
      $j('input').off('focus', handleFocus);
      focusCount = 0;
    }
  });
}

function addMessage(placeId, msg, color = 'red') {
  const wrapper = $j('#order-feedback');
  const el = $j(`#${placeId}`);
  const finalMsg = (color !== 'red')
    ? `<span style="color:${color}">${msg}</span>`
    : msg;

  // Check if the message already exists
  if (!el.html().includes(finalMsg)) {
    const lineBreak = (el.html() !== '') ? '<br>' : '';
    el.html(`${el.html()}${lineBreak}${finalMsg}`);
  }

  el.fadeIn(400);
  wrapper.fadeIn(400);
  onFocusFadeOutMessages();
}

function stateValueSetter(adjustedElement) {
  $j('#state').val(adjustedElement.val());
}

function sendToAAC() {
  // console.log('sending to AAC');

  window.setTimeout(() => {
    window.location.href = 'https://adoptacollege.org/#have-fun';
  }, 6000);
}

async function submitOrder(submittingForm) {
  const data = $j('#volunteer-booklet-form').serializeFormJSON();
  data.action = 'volunteer_booklet_order_form_submission';
  let response;

  try {
    response = await glsAjax({ data });
  } catch (err) {
    logToPHP(`volunteer_booklet_form_submission ajax error.
      Error: ${JSON.stringify(err)}
      UA: ${navigator.userAgent}
      Online: ${navigator.onLine}
      Time: ${new Date().toISOString()}
    `);
    addMessage('result', 'Your order didn\'t go through because the internet connection dropped for a moment (err:01). Please check your connection and resubmit your order. If it happens again, please contact us at info@veganoutreach.org.');
    markFormProcessing(submittingForm, false);
    return;
  }

  if (!response.success) {
    addMessage('result', response.msg);
  } else if (!response.code) {
    logToPHP(`volunteer_booklet_form_submission missing code (err:02). Response: ${JSON.stringify(response)}, Online: ${navigator.onLine}`);
    addMessage('result', 'We hit a snag finishing your order (err:02). We received your information, but payment was not processed. Please try submitting again. If the issue continues, contact us at info@veganoutreach.org.');
    markFormProcessing(submittingForm, false);
  } else {
    addMessage('result', response.msg, 'green');
    if (typeof response.remaining_packets !== 'undefined' && response.remaining_packets >= 1) {
      // Stay on page – allow user to adjust quantity
      addMessage('result', 'Please adjust your order and resubmit.', 'red');
      markFormProcessing(submittingForm, false);
    } else if (typeof response.remaining_packets !== 'undefined' && response.remaining_packets === 0) {
      addMessage('result', 'Thank you for your support! You will be redirected to Adopt A College for more information on leafleting.', 'green');
      sendToAAC();
    } else {
      sendToAAC();
    }
  }
}

// manually clear all messages
// timed clearing happens another way
function clearMessagesHTML() {
  $j("div[name$='-message']").html('');
  $j("div[name='result']").html('');
}

function upToOrAtIncrementsOf(target, qty) {
  if (qty > target && qty % target) {
    const overTarget = qty % target;
    //
    // always round down
    //
    return qty - overTarget;
  }
  if (qty < 0) {
    return 0;
  }
  return qty;
}

// TODO get bouncer to replace this
//
function validateOrderForm() {
  let isValid = true;

  // something ordered?
  //
  if ($j('#subtotal').val() === '$0.00') {
    addMessage('submit-message', 'Select items to order above before continuing.');
    isValid = false;
  }

  return isValid;
}

function isCounting(contender) {
  return (
    Math.floor(contender) === parseInt(contender, 10)
    && $j.isNumeric(contender)
    && contender > 0
  );
}

function totFromQtyAndPacket(qty, packetsize) {
  if (isCounting(qty)) {
    // get the packetsize
    //

    if ($j.isNumeric(packetsize)) {
      // update total
      //
      return qty * packetsize;
    }

    // packetsize error - show 0
    //
    return 0;
  }

  // qty not a counting number - show 0
  //
  return 0;
}

function onStateChange(el) {
  stateValueSetter(el);
  //
  // shipping
  //
  // updateStateAndCountryShipAlert();
  // taxes
  //
  // totals();
}

function zeroOrNumber(num) {
  return (isCounting(num)) ? parseInt(num, 10) : 0;
}

function updateItemShipQty() {
  let shipQty = 0;

  $j('.updatesItemShipQty').each(function loopUpdatesItemShipQty() {
    shipQty += zeroOrNumber($j(this).val());
  });

  $j("input[name$='_sq'], select[name$='_sq']").change(function loopSQ() {
    shipQty += zeroOrNumber($j(this).val());
  });

  $j('#item-ship-qty').val(shipQty);
}

function updateBookletTotals() {
  let totalBooklets = 0;

  // First: update each _b and compute total
  $j('.updatesItemShipQty').each(function computeTotal() {
    const qty = parseInt($j(this).val(), 10) || 0;
    const booklets = qty * PACKET_SIZE;

    const baseId = this.id.replace('_q', '');
    $j(`#${baseId}_b`).val(booklets);

    totalBooklets += booklets;
  });

  // Update the total field
  $j('#booklet-ship-qty').val(totalBooklets);

  if (totalBooklets > 0) {
    $j('#submit-button').css('display', 'block');
  } else {
    $j('#submit-button').css('display', 'none');
  }

  // Second: update allowed options for each select
  $j('.updatesItemShipQty').each(function allowedOptions() {
    const $select = $j(this);
    const currentQty = parseInt($select.val(), 10) || 0;
    const currentBooklets = currentQty * PACKET_SIZE;

    // Total excluding this select
    const otherBooklets = totalBooklets - currentBooklets;
    const remainingBooklets = MAX_BOOKLETS - otherBooklets;

    // Max packets this select can allow
    const maxPackets = Math.floor(remainingBooklets / PACKET_SIZE);

    $select.find('option').each(function disableInvalidOptions() {
      const optionQty = parseInt(this.value, 10);

      // Always allow current selection
      if (optionQty === currentQty) {
        this.disabled = false;
        return;
      }

      this.disabled = optionQty > maxPackets;
    });

    // Gray out select if nothing is available
    if (maxPackets === 0 && currentQty === 0) {
      $select.prop('disabled', true);
    } else {
      $select.prop('disabled', false);
    }

    updateItemShipQty();
  });
}

window.addEventListener('pageshow', () => {
  updateBookletTotals();
});

$j(() => {
  if ($j('#volunteer-booklet-form').length > 0) {
    const bouncer = new Bouncer('#contact-form', {
      disableSubmit: true,
      messageAfterField: false,
    });

    updateItemShipQty();
    $j(document).on('change', '.updatesItemShipQty', updateBookletTotals);

    $j("input[name$='_q'], select[name$='_q']").change(function loopQ() {
      const el = $j(this);

      // which field? (get the prefix)
      //
      const fieldPrefix = (el.attr('name').split('_'))[0];

      // validate qty counting number
      //
      let qtySubmitted = parseInt(el.val(), 10);
      let qty = qtySubmitted;

      if (!isCounting(qty)) {
        qty = Math.floor(qty);
        qty = (qty > 0) ? qty : 0;
        // handle error silently
        qtySubmitted = 0;
      }

      const maxValue = el.attr('max');

      if (typeof maxValue !== typeof undefined && maxValue !== false) {
        if (qty > maxValue) {
          qty = maxValue;
        }
      }

      // validate qty against restrictions
      //
      if (el.hasClass('totalOf100')) {
        qty = upToOrAtIncrementsOf(100, qty);

        if (qtySubmitted !== qty) {
          addMessage(
            'booklet-message', `Your quantity has been changed from ${
              qtySubmitted} to ${qty
            }. This booklet can be ordered in singles up to 50 or in multiples of 50.`,
          );
        }
      }

      // qty is now valid
      //
      el.val(qty);

      // get the booklet total as a number
      //
      const packetSize = (el.attr('class').split('_'))[1];

      // get the total number of packets
      //
      const totalBooklets = totFromQtyAndPacket(qty, packetSize);

      // display it
      //
      $j(`#${fieldPrefix}_b`).val(totalBooklets);
    });

    $j('.state-proxy').change(function loopStateProxy() {
      onStateChange($j(this));
    });

    //  form submission attempt
    //
    $j('#volunteer-booklet-form').find('.volunteer-booklet-order-submitter').click(async function handleOrderSubmitterClick(event) {
      event.preventDefault();
      const submittingForm = $j(this).closest('form');

      if (isFormProcessing(submittingForm)) {
        addMessage('result', 'Hold on, still processing&hellip;');
        return;
      }

      markFormProcessing(submittingForm, true);
      $j(this).blur();
      clearMessagesHTML();

      // [0] gets htmlelements
      const arrayOfInvalidElements = bouncer.validateAll(submittingForm[0]);

      if (
        !Array.isArray(arrayOfInvalidElements)
        || arrayOfInvalidElements.length > 0
      ) {
        markFormProcessing(submittingForm, false);
        return;
      }

      if (validateOrderForm() === false) {
        markFormProcessing(submittingForm, false);
        return;
      }

      addMessage('result', 'Processing form&hellip;', 'green');
      const gaction = ($j('#liveOrTest').val() === 'test')
        ? 'order_form_test_submit'
        : 'order_form_submit';
      const gresponse = await grecaptchaV3Execute(gaction);

      if (
        !Object.prototype.hasOwnProperty.call(gresponse, 'success')
        || !gresponse.success
      ) {
        if (navigator.onLine) {
          logToPHP(`volunteer_booklet_form_submission grecaptcha failure (err:03). Response: ${JSON.stringify(gresponse)}, UA: ${navigator.userAgent}`);
        }
        addMessage('result', 'Something went wrong while verifying your order (err:03). This is usually caused by a brief network issue or a browser setting blocking scripts. Please try resubmitting. If it happens again, please contact us at info@veganoutreach.org.');
        markFormProcessing(submittingForm, false);
        return;
      }

      submitOrder(submittingForm);
    });
  }

  $j.fn.serializeFormJSON = function serializeFormJSON() {
    const o = {};
    const a = this.serializeArray();

    $j.each(a, function loopA() {
      if (o[this.name]) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }

        o[this.name].push(this.value || '');
      } else {
        o[this.name] = this.value || '';
      }
    });

    return o;
  };
});
